import { AxiosPromise } from 'axios';
import 
    * as
    CatalogProvider
    from '../../providers/catalog/catalogProvider';
import { RobloxCatalogApiMultigetItemDetailsRequestModel } from '../../providers/catalog/catalogProvider';

const bundleApiInstance = new CatalogProvider.BundleApi();
const catalogApiInstance = new CatalogProvider.CatalogApi();

const getRecommendations = (bundleId: number, numItems?: number): AxiosPromise<CatalogProvider.RobloxWebWebAPIModelsApiArrayResponseRobloxCatalogApiBundleDetailsModel> => {
    return bundleApiInstance.v1BundlesBundleIdRecommendationsGet(bundleId, numItems, { withCredentials: true });
};

const postItemDetails = (model: RobloxCatalogApiMultigetItemDetailsRequestModel): AxiosPromise<CatalogProvider.RobloxWebWebAPIModelsApiArrayResponseRobloxCatalogApiCatalogSearchDetailedResponseItem> => {
    return catalogApiInstance.v1CatalogItemsDetailsPost(model, { withCredentials: true });
};

export default {
    getRecommendations,
    postItemDetails
};
